import { enableProdMode } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { CalensoPricingTableComponent } from '@app/calenso-pricing-table.component';
import { environment } from '@environments/environment';
import * as Sentry from "@sentry/angular";
import { SentryConfig } from '@src/sentry.config';

if (environment?.production) {
  enableProdMode();
  Sentry.init(SentryConfig);
}

(async () => {
  const app = await createApplication(appConfig);

  const inputElement = createCustomElement(CalensoPricingTableComponent, {
    injector: app.injector,
  });
  customElements.define('calenso-pricing-table', inputElement);
})();
